import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ModuleAccessTab from "./tabs/ModuleAccessTab";
import ProcessorAccessTab from "./tabs/ProcessorAccessTab";

const EmployeeTransactionAccessModule = ({
  user,
  moduleData,
  processorData,
  searchData,
  updateAccess,
  saveProcessorAccess,
  showGeneralMessage
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabSelect = (index) => {
    setActiveTab(index);
    searchData(""); // REPLACED: Clear search when toggling tabs
  };

  return (
    <div className='loan-tab p-4 space-y-4'>
      <Tabs selectedIndex={activeTab} onSelect={handleTabSelect}>
        <TabList>
          <Tab><b>MODULE ACCESS</b></Tab>
          <Tab><b>PROCESS MANAGER ACCESS</b></Tab>
        </TabList>

        <div className="loan-tabPanel mt-4">
          <TabPanel>
            <ModuleAccessTab
              user={user}
              data={moduleData}
              searchData={(val) => searchData(val, 0)}
              updateAccess={updateAccess}
            />
          </TabPanel>
          <TabPanel>
            <ProcessorAccessTab
              user={user}
              data={processorData}
              searchData={(val) => searchData(val, 1)}
              saveProcessorAccess={saveProcessorAccess}
              showGeneralMessage={showGeneralMessage}
            />
          </TabPanel>
        </div>
      </Tabs>
    </div>
  );
};

export default EmployeeTransactionAccessModule;